import React, { Component } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Bar } from 'react-chartjs-2';
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend,
} from 'chart.js';
import { useTranslation } from 'react-i18next';

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

class NotificationsChart extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        const notificationsData = this.props.notificationsData;
        const t = this.props.t;
        const getDatesForWeek = () => {
            const currentDate = new Date();
            const currentDayOfWeek = currentDate.getDay();
            const daysUntilMonday = currentDayOfWeek === 0 ? 6 : currentDayOfWeek - 1;
            const mondayDate = new Date(currentDate);
            mondayDate.setDate(currentDate.getDate() - daysUntilMonday);

            const dates = [];
            for (let i = 0; i < 7; i++) {
                const date = new Date(mondayDate);
                date.setDate(mondayDate.getDate() + i);
                dates.push({
                    date: date.toISOString().slice(0, 10) + 'T00:00:00',
                    EventAcceptedCount: 0,
                    EventEditedCount: 0,
                    EventNotifiedCount: 0,
                    EventRejectedCount: 0,
                });
            }

            return dates;
        };

        const getNotificationsForLastWeek = () => {
            const lastWeekNotification = [];

            getDatesForWeek().forEach((notification) => {
                const matchingItem = notificationsData.find((item) => item.EventDate === notification.date);
                const newItem = matchingItem
                    ? {
                        EventAcceptedCount: matchingItem.EventAcceptedCount,
                        EventEditedCount: matchingItem.EventEditedCount,
                        EventNotifiedCount: matchingItem.EventNotifiedCount,
                        EventRejectedCount: matchingItem.EventRejectedCount,
                    }
                    : {
                        EventAcceptedCount: 0,
                        EventEditedCount: 0,
                        EventNotifiedCount: 0,
                        EventRejectedCount: 0,
                    };
                lastWeekNotification.push(newItem);
            });

            return lastWeekNotification;
        };

        const labels = [t('home.notificationChart.Mon'), t('home.notificationChart.Tue'), t('home.notificationChart.Wed'), t('home.notificationChart.Thu'), t('home.notificationChart.Fri'), t('home.notificationChart.Sat'), t('home.notificationChart.Sun')];

        const notifies = getNotificationsForLastWeek();

        const data = {
            labels,
            datasets: [
                {
                    label: t('home.notificationChart.labelAccepted'),
                    data: notifies.map((n) => n.EventAcceptedCount),
                    backgroundColor: 'rgb(77, 212, 172)',
                },
                {
                    label: t('home.notificationChart.labelNotified'),
                    data: notifies.map((n) => n.EventNotifiedCount),
                    backgroundColor: 'rgb(61, 139, 253)',
                },
                {
                    label: t('home.notificationChart.labelEdited'),
                    data: notifies.map((n) => n.EventEditedCount),
                    backgroundColor: 'rgb(253, 152, 67)', // Added dataset for EventEditedCount
                },
            ],
        };

        const options = {
            plugins: {
                title: {
                    display: false,
                    text: '',
                },
            },
            responsive: true,
            scales: {
                x: {
                    stacked: true,
                },
                y: {
                    stacked: true,
                },
            },
        };

        return (
            <div className="d-flex flex-column border rounded-3 shadow-sm bg-white m-0 mt-2 p-0">
                <div className="m-0 p-0 border-bottom py-1">
                    <p className="text-secondary m-0 p-0 text-center font-weight-600 lh-1 py-1">
                        <i className="bi bi-graph-up pe-2"></i>{t('home.notificationChart.title')}
                    </p>
                </div>
                <Bar options={options} data={data} />
            </div>
        );
    }
}

function withMyHook(Component) {
    return function WrappedComponent(props) {
        const notificationsData = useSelector((state) => state.notification.notificationsData);
        const userData = useSelector((state) => state.currentUser.userData);
        const dispatch = useDispatch();
        const { t } = useTranslation();

        return <Component {...props} userData={userData} notificationsData={notificationsData} dispatch={dispatch} t={t } />;
    };
}

export default withMyHook(NotificationsChart);
